import { Injectable } from '@angular/core';

import { ApiService, LogService, AppContext, Carrier } from './../shared';

declare const moment: any;

@Injectable()
export class ContactCarrierService {
  show: boolean = false;
  schedule: any;

  route: string = '';
  company: string = '';
  website: string = '';

  constructor(private api: ApiService, private logger: LogService, private app: AppContext) {
  }

  getWebsite() {
    // clear if re-opening for a different carrier
    this.company = '';
    this.website = '';

    try {
      let origin = this.formatPort(this.schedule.departurePort);
      let start = moment(this.schedule.departure).format('MMM Do YYYY');
      let destination = this.formatPort(this.schedule.arrivalPort);
      let end = moment(this.schedule.arrival).format('MMM Do YYYY');
      this.route = origin + ' ' + start + ' to ' + end + ' ' + destination;
    } catch (ex) {
      this.route = 'the desired route';
    }

    this.api.getApiClient().then(client => this.callGetCarrier(client, this.schedule.carrier.id));
  }

  formatPort(item: any): string {
    let display = '';
    try {
      display = item.name + ' [' + item.code + '], ' + item.region.name + ', ' + item.country.name;
    } catch (ex) {
      if (item.region === null && item.country !== null) {
        display = item.name + ' [' + item.code + '], ' + item.county.name;
      } else {
        display = item.name + ' [' + item.code + ']';
      }
    }
    return display;
  }

  callGetCarrier(apigClient: any, carrierId) {
    this.logger.log('contact-carrier.service', 'callGetCarrier', this.schedule);
    let params = {};
    let additionalParams = {
      headers: { 'Content-Type': 'application/json' },
      queryParams: {
        id: carrierId
      }
    };
    try {
      apigClient.carriersGet(params, '', additionalParams)
        .then((result) => {
          this.logger.log('contact-carrier.service', 'carrier result', result);
          let carrier = new Carrier(result.data.items[0], this.app.accountType);

          this.company = carrier.company;
          this.website = carrier.website;
        }).catch((err) => this.api.handleError(err));
    } catch (ex) {
      this.app.showMessage('Error', 'We were unable to retrieve the website for the carrier. Please try again');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/contact-carrier/contact-carrier.service.ts